import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ApproveRejectService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadCompanyApi() {
		return this.ngrxService.loadInitAPI('company', 'data');
	}

	loadCompanyDataApi(status = 'pending') {
		return this.loadCompanyData(status).pipe(
			map(data => this.ngrxService.loadInitData('company', 'data', data)),
		);
	}

	fetchCompanyData() {
		return this.ngrxService.loadData('company', 'data');
	}

	loadCompanyData(status = 'pending') {
		return this.http.get(
			environment.url.company + `/company/status/${status}/list`,
		);
	}

	updateCompanyNgrx(companyId: any, status: any, currentListStatus: any) {
		return this.http
			.post(
				environment.url.company + `/company/${companyId}/status/${status}`,
				{},
			)
			.pipe(tap(() => this.loadCompanyDataApi(currentListStatus).subscribe()));
	}
}
